import {call, put, select, take, takeEvery} from 'redux-saga/effects';
import {getAccountToken} from '../selectors';
import {
    FILE_UPLOAD_CANCEL,
    FILE_UPLOAD_ERROR,
    FILE_UPLOAD_REQUEST,
    FILE_UPLOAD_SUCCESS,
    fileUploadError,
    fileUploadProgress,
    fileUploadSuccess,
} from '../modules/vegetation/actions';
import {showMessage} from '../actions'
import {getApiUrl} from '../config'
import map from 'lodash/map'
import createFileUploadChannel from './channel/createFileUploadChannel'

const uploadFileRequests = {};

function * clearFileUpload(action) {
    uploadFileRequests[action.payload.id] = undefined;
    yield call(() => {})
}

function * cancelFileUpload(action) {
    if(uploadFileRequests[action.payload.id]) {
        var uploadFileRequest = uploadFileRequests[action.payload.id];
        uploadFileRequests[action.payload.id] = undefined;
        uploadFileRequest.abort();
        yield call(() => {})
    }
}

function* callFileUpload(action) {
    if(!action.payload) {
        console.warn('payload is empty')
    }
    else {
        const fileId = action.payload.id;

        try {
            const token = yield select(getAccountToken);

            var data = new FormData();
            data.append('file', action.payload.file, action.payload.file.name);

            var upload_file_request = new XMLHttpRequest();
            upload_file_request.open(action.payload.method, getApiUrl() + (action.payload.path || `api/file/upload/${fileId}`));
            upload_file_request.setRequestHeader('Authorization', 'Bearer ' + token);
            upload_file_request.setRequestHeader('Accept', 'application/json, application/xml, text/plain, text/html, *.*');

            uploadFileRequests[action.payload.id] = upload_file_request;

            const channel = yield call(createFileUploadChannel, upload_file_request, data);
            while (true) {
                const {progress = 0, err, success, response} = yield take(channel);
                if (err) {
                    if (uploadFileRequests[fileId]) {
                        console.error(err);
                        yield put(fileUploadError(fileId, err));
                        if(err.message)
                            yield put(showMessage('error', (err.message || err) + ':\r\n' + map(err.errors, x => x.message).join('\r\n')));
                        else
                            yield put(showMessage('error', err));
                        return;
                    }
                }
                if (success) {
                    yield put(fileUploadSuccess(response));
                    return;
                }
                yield put(fileUploadProgress(fileId, progress));
            }

        } catch (e) {
            console.log('catch',e);
            if (uploadFileRequests[fileId]) {
                console.error(e);
                yield put(fileUploadError(fileId, e));
                yield put(showMessage('error', e.message))
            }
        }
    }
}

export default function* FileUploadSaga() {
    yield takeEvery(FILE_UPLOAD_REQUEST, callFileUpload);
    yield takeEvery(FILE_UPLOAD_CANCEL, cancelFileUpload);
    yield takeEvery(FILE_UPLOAD_SUCCESS, clearFileUpload);
    yield takeEvery(FILE_UPLOAD_ERROR, clearFileUpload);

};


// WEBPACK FOOTER //
// ./src/saga/fileUploadSaga.js